import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_empty_state.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { Props, DivAttributes } from '../utils/types'

export interface EmptyStateProps extends Props {
  actions?: Function
  description?: string
  image?: string
  title?: string
}

const cx = bind(styles)

export const EmptyState = React.forwardRef<
  HTMLDivElement,
  DivAttributes & EmptyStateProps
>(
  (
    { image, title, description, actions, className, children, ...props },
    ref
  ) => (
    <div ref={ref} className={cx('core-empty-state', className)} {...props}>
      {image && (
        <Image>
          <img src={image} />
        </Image>
      )}
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
      {actions && <Actions>{actions}</Actions>}
      {children}
    </div>
  )
)

export const Actions = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ children }, ref) => (
    <div ref={ref} className={cx('core-empty-state__actions')}>
      {children}
    </div>
  )
)

export const Description = React.forwardRef<
  HTMLDivElement,
  DivAttributes & Props
>(({ children }, ref) => (
  <div ref={ref} className={cx('core-empty-state__description')}>
    {children}
  </div>
))

export const Image = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ children }, ref) => (
    <div ref={ref} className={cx('core-empty-state__image')}>
      {children}
    </div>
  )
)

export const Title = React.forwardRef<HTMLDivElement, DivAttributes & Props>(
  ({ children }, ref) => (
    <div ref={ref} className={cx('core-empty-state__title')}>
      {children}
    </div>
  )
)

EmptyState.displayName = 'EmptyState'

Actions.displayName = 'EmptyState.Actions'

Description.displayName = 'EmptyState.Description'

Image.displayName = 'EmptyState.Image'

Title.displayName = 'EmptyState.Title'

export default addSubcomponents(
  {
    Actions,
    Description,
    Image,
    Title,
  },
  EmptyState
)
